import React, { useEffect, useRef } from "react";

const FlexibleTextarea = ({
  name,
  label,
  register,
  placeholder = "Type here...",
  className = "",
  outerClassName = "w-full",
  minRows = 2,
  maxRows = 10,
  errors = {},
  required = false,
  ...props
}) => {
  const textareaRef = useRef(null);

  const handleInput = (e) => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    textarea.style.height = "auto"; // Reset height
    textarea.style.height = `${Math.min(
      textarea.scrollHeight,
      maxRows * 24
    )}px`; // Adjust height dynamically

    if (props.onChange) props.onChange(e);
  };

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${Math.min(
        textarea.scrollHeight,
        maxRows * 24
      )}px`;
    }
  }, []);

  return (
    <div className={outerClassName}>
      {label && (
        <label htmlFor={name} className="block mb-1 font-bold">
          {label}
          {required && <span className="text-red-500 text-xs ml-0.5">*</span>}
        </label>
      )}
      <textarea
        id={name}
        ref={textareaRef}
        {...register(name)}
        onInput={handleInput}
        placeholder={placeholder}
        rows={minRows}
        className={`w-full resize-none overflow-hidden border ${
          errors[name]
            ? "border-red-500 focus:ring-red-500"
            : "border-gray-300 focus:border-blue-500 focus:ring-blue-500"
        } focus:ring-1 rounded-lg p-3 text-gray-900 bg-white shadow-sm ${className}`}
        style={{
          minHeight: `${minRows * 24}px`,
          maxHeight: `${maxRows * 24}px`,
        }}
        {...props}
      />
      {errors[name] && (
        <p className="text-red-500 text-xs mt-1">{errors[name]?.message}</p>
      )}
    </div>
  );
};

export default FlexibleTextarea;
